import * as React from "react";

const ReadRedshift = (props: any) => (
  <svg width={64} height={64} viewBox="0 0 64 64" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="none" d="M0 0h64v64H0z" fillOpacity={0} />
      <g fill="#7B838C">
        <path d="M26 21h12v22H26zM22 24h3v16h-3a2 2 0 0 1-2-2V26a2 2 0 0 1 2-2zM39 24h3a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-3V24z" />
      </g>
      <path d="M48 23.515L56.485 32 48 40.485z" fill="#D2D5D8" />
    </g>
  </svg>
);

export default ReadRedshift;

